import React, { useState } from "react";
import { Col, Row } from "antd";
import SearchControl from "../../../../../../../../components/SearchControls/SearchGroups/SearchControl";
import FilterGroupAccordion, {
  hasActiveValue,
  mergeUnnamedIntoFirst
} from "../../../../../../../../components/SearchControls/SearchGroups/FilterGroupAccordion";
import MobileSearchGroup from "../MobileSearchGroup";
import styles from "./style.scss";

const MobileAllSearchControls = props => {
  const { groupConfigs: rawGroupConfigs, form, onSubmit, onReset, isMobile, showAllControls, maxWidth } = props;
  const groupConfigs = mergeUnnamedIntoFirst(rawGroupConfigs);
  const [explicitOpen, setExplicitOpen] = useState({});

  const getIsOpen = (index, controls) => {
    if (explicitOpen[index] !== undefined) return explicitOpen[index];
    if (hasActiveValue(controls)) return true;
    if (index === 0) return true;
    return false;
  };
  const toggleGroup = (index, controls) => {
    setExplicitOpen({ ...explicitOpen, [index]: !getIsOpen(index, controls) });
  };

  return (
    <div style={{ display: showAllControls ? "block" : "none" }}>
      <div style={{ maxWidth }}>
        {groupConfigs.map((groupConfig, index) => {
          const isOpen = getIsOpen(index, groupConfig.controls);
          // Index 0 reuses MobileSearchGroup so the primary-fields layout
          // matches the closed-panel quick-search bar one-to-one.
          const body = index === 0 ? (
            <MobileSearchGroup
              form={form}
              groupConfig={groupConfig}
              onSubmit={onSubmit}
              onReset={onReset}
              isMobile={isMobile}
              showAllControls={false}
              maxWidth={maxWidth}
              hideSearchButton={true}
            />
          ) : (
            <Row type="flex" gutter={12}>
              {groupConfig.controls.map((controlConfig, i) => (
                <Col span={24} key={i} className={styles.column}>
                  <SearchControl
                    key={i}
                    form={form}
                    controlConfig={controlConfig}
                    isMobile={isMobile}
                    onSubmit={onSubmit}
                    showPlaceholder={true}
                  />
                </Col>
              ))}
            </Row>
          );
          return (
            <div key={index} className={styles.rowWrapper}>
              <FilterGroupAccordion
                name={groupConfig.name || "Osnovni podaci"}
                isOpen={isOpen}
                onToggle={() => toggleGroup(index, groupConfig.controls)}
                titleClassName={styles.title}
              >
                {body}
              </FilterGroupAccordion>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MobileAllSearchControls;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/SubLevel1/SubLevel1Desktop/FilterSection/SearchControls/SearchGroups/MobileAllSearchControls/index.tsx